<template>

	<div class="highcharts" id="timeseries"></div>

</template>
<script type="text/javascript">

import HC from 'highcharts'

export default {
	computed: {
		serie() {
			return _.zip(
				this.$store.state.basket.index,
				this.$store.state.basket.series
			)
		},
	},
	mounted() {
		var myChart = HC.chart('timeseries', {
			chart: {
				type:'line',
				zoomType: 'x',
				renderTo: 'container',
			},
			title: {
				text: ''
			},
			xAxis: {
				type: 'datetime',
				labels: {
					align: 'right',
					rotation: -30
				},
			},
			tooltip: {
				xDateFormat: '%Y - %a, %b %d, %H:%M (UTC)',
				shared: true
			},
			plotOptions: {
				series: {
					connectNulls: false
				},
				area: {
					connectNulls: false,
					threshold: null,
					marker: {
						radius: 2
					},
					states: {
						hover: {
							lineWidth: 1
						}
					},
					lineWidth: 1,
					fillColor: {
						linearGradient: {
							x1: 0,
							y1: 0,
							x2: 0,
							y2: 1
						},
						stops: [
							[0, HC.getOptions().colors[0]],
							[1, HC.Color(HC.getOptions().colors[0]).setOpacity(0).get('rgba')]
						]}
				}
			},
			series: this.$store.state.basket.series
		})
	}
}

</script>
<style type="text/css">
	div.highcharts {
		min-height: 85vh;
		width: 100%;
	}
</style>
